import { MpSdk } from 'src/types';

export class Tour {
  tour: MpSdk.Tour;

  private mpSDK: MpSdk;

  constructor(mpSDK: MpSdk) {
    this.mpSDK = mpSDK;
    this.tour = mpSDK.Tour;
  }

  async moveToStep(step: number) {
    await this.tour.step(step);
  }

  async measurementsMode(tourPlaying: any) {
    if (tourPlaying) {
      await this.tour.stop();
    }
    await this.mpSDK.Measurements.toggleMode(true);
  }

  async playTour(tourPlaying: any, reelStep: any) {
    if (!tourPlaying) {
      await this.tour.start(reelStep);
    } else {
      await this.tour.stop();
    }

    return {
      panoramaOn: false,
    };
  }

  async changeViewMode(mode: MpSdk.Mode.Mode, tourPlaying: any) {
    if (tourPlaying) {
      await this.mpSDK.Tour.stop();
    }
    await this.mpSDK.Mode.moveTo(mode);

    return { panoramaOn: false };
  }
}
